import script from "./TesekkurScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./TesekkurScreen.vue?vue&type=script&setup=true&lang=js"

import "./TesekkurScreen.vue?vue&type=style&index=0&id=1558e282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1558e282"]])

export default __exports__